import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5595 4.24727L5.55953 11.2473C5.5189 11.288 5.47065 11.3202 5.41754 11.3422C5.36442 11.3643 5.30749 11.3756 5.25 11.3756C5.1925 11.3756 5.13557 11.3643 5.08246 11.3422C5.02935 11.3202 4.9811 11.288 4.94047 11.2473L1.87797 8.18477C1.79588 8.10268 1.74976 7.99134 1.74976 7.87524C1.74976 7.75915 1.79588 7.6478 1.87797 7.56571C1.96006 7.48362 2.0714 7.4375 2.1875 7.4375C2.3036 7.4375 2.41494 7.48362 2.49703 7.56571L5.25 10.3192L11.9405 3.62821C12.0226 3.54612 12.1339 3.5 12.25 3.5C12.3661 3.5 12.4774 3.54612 12.5595 3.62821C12.6416 3.7103 12.6877 3.82165 12.6877 3.93774C12.6877 4.05384 12.6416 4.16518 12.5595 4.24727Z",
		fill: "currentColor"
	})
});
export default SvgCheckIcon;
